import React from 'react';

/**
 * 라인(스트로크) 아이콘 세트. 이모지 대신 사용.
 * currentColor를 따르므로 부모의 color로 색을 지정한다.
 */
const PATHS = {
  // services
  pen: (<><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></>),
  phone: (<><rect x="6.5" y="2.5" width="11" height="19" rx="2.5" /><path d="M11 18.5h2" /></>),
  browser: (<><rect x="3" y="4.5" width="18" height="15" rx="2" /><path d="M3 9.5h18" /><path d="M6.4 7h.01M8.9 7h.01" /></>),

  // team
  person: (<><circle cx="12" cy="8" r="3.5" /><path d="M5.5 20a6.5 6.5 0 0 1 13 0" /></>),
  layers: (<><path d="M12 3l8.5 4.5L12 12 3.5 7.5 12 3z" /><path d="M3.5 12L12 16.5 20.5 12" /><path d="M3.5 16.5L12 21l8.5-4.5" /></>),
  server: (<><rect x="3.5" y="4" width="17" height="7" rx="1.5" /><rect x="3.5" y="13" width="17" height="7" rx="1.5" /><path d="M7 7.5h.01M7 16.5h.01" /></>),

  // advantages
  bolt: (<><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" /></>),
  chat: (<><path d="M20 11.5a7.5 7.5 0 0 1-10.5 6.86L4 20l1.64-4.9A7.5 7.5 0 1 1 20 11.5z" /></>),
  tag: (<><path d="M3.5 3.5h7l10 10-7 7-10-10v-7z" /><circle cx="7.5" cy="7.5" r="1.3" /></>),
  target: (<><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.4" /></>),
  gear: (<><circle cx="12" cy="12" r="3.2" /><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M5.6 18.4l1.8-1.8M16.6 7.4l1.8-1.8" /></>),
  pin: (<><path d="M12 21.5s-6.5-5.2-6.5-10.5a6.5 6.5 0 0 1 13 0c0 5.3-6.5 10.5-6.5 10.5z" /><circle cx="12" cy="11" r="2.3" /></>),
};

export default function Icon({ name, size = 24, strokeWidth = 1.6, className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name] || null}
    </svg>
  );
}
